<div class="phone-component">
  <label *ngIf="item">{{item.translation_key|| item.label| translation|translationFromString | transformText
    :item?.text_transform }}</label>

  <div>
    <p-inputgroup class="cc">
      <p-select [(ngModel)]="phoneNumber.cc" [options]="countryCodes" optionLabel="name" optionValue="value"
        [placeholder]="'country_code'| translation" (onChange)="numberChanged()" [disabled]="checkDisable()" fluid ngDefaultControl>
      </p-select>
    </p-inputgroup>
  </div>
  <div class="phone-div">
    <div class="form-field area-code">
      <input pInputText [placeholder]="'area_code'| translation" [(ngModel)]="phoneNumber.areaCode"
        (ngModelChange)="numberChanged()" [disabled]="checkDisable()" fluid />
    </div>
    <div class="form-field phone-number">
      <input pInputText [placeholder]="'phone_number'| translation" [(ngModel)]="phoneNumber.subscriberNumber"
        (ngModelChange)="numberChanged()" [disabled]="checkDisable()" fluid />
    </div>
  </div>

</div>